import api from '@/services/api'
const url = action => `/holdervisitrecords/${action}`

export async function postFindHolderVisitRecord(holder_id, page, itemsPerPage){
    var requestBody = {
        query_data: {
            type: "query",
            query_options: [
                { 
                    queryField: "holder_id",
                    queryType: "=",
                    queryData: holder_id
                }
            ],
            pagination: {
                itemsPerPage: itemsPerPage
            }
        }
    }
    const { data: res } = await api.post(url('findByCondition?page=' + page),requestBody) //把response.data 的值傳給res
    return res
}
/* 
export async function getHolderVisitRecord(id){
    const { data: res } = await api.get(url('/' + id)) 
    return res
}
*/

export async function postCreateHolderVisitRecord(params){
    const { data: res } = await api.post('/holdervisitrecords', params) 
    return res
}

export async function putHolderVisitRecord(id, params){
    const { data: res } = await api.put(url(id), params) 
    return res
}

export async function deleteHolderVisitRecord(id){
    const { data: res } = await api.delete(url( id)) 
    return res
}